import {
	Box,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { Image } from 'components';
import { useMenu } from 'hooks';

const BenefitItem = ({
	benefit,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleEditClick(benefit, e)}>Edit</MenuItem>
			<MenuItem onClick={(e) => handleDeleteClick(benefit, e)}>Delete</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(benefit.id);

	return (
		<TableRow
			hover
			onClick={() => handleClick(benefit)}
			sx={{ cursor: 'pointer' }}
		>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected}
						onChange={() => handleSelect(benefit)}
						name="benefit"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image src={benefit.thumbnail_url} variant="rounded" size={80} />
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{benefit.title}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{benefit.expires_at}</Typography>
			</TableCell>
			<TableCell>
				<Typography variant="primary.text">{benefit.url}</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton
					onClick={(e) => {
						e.stopPropagation();
						handleToggleMenu(e);
					}}
				>
					<MoreHoriz />
				</IconButton>
				{renderMenu()}
			</TableCell>
		</TableRow>
	);
};

export default BenefitItem;
